import { render, staticRenderFns } from "./WarehouseTabInvoice.vue?vue&type=template&id=6855a502&scoped=true"
import script from "./WarehouseTabInvoice.vue?vue&type=script&lang=js"
export * from "./WarehouseTabInvoice.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabInvoice.vue?vue&type=style&index=0&id=6855a502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6855a502",
  null
  
)

export default component.exports